// Dark mode tokens — approved palette from design session
export const DARK_TOKENS = {
  // Backgrounds
  bgApp: '#0D0E12',
  bgCard: '#15171E',
  bgAgent: '#1C1A27',
  bgElevated: 'rgba(255,255,255,0.02)',
  bgIcon: 'rgba(255,255,255,0.05)',

  // Borders
  borderDefault: 'rgba(255,255,255,0.05)',
  borderPurple: 'rgba(168,85,247,0.2)',
  borderDivider: 'rgba(255,255,255,0.05)',
  borderInput: 'rgba(255,255,255,0.12)',

  // Accents
  teal: '#5eead4',
  emerald: '#34d399',
  purple: '#9333ea',
  purpleText: '#a78bfa',
  red: '#ef4444',
  amber: '#f59e0b',
  warmCopper: '#E8927C',

  // Glows
  glowPurpleCard: '0 0 20px rgba(168,85,247,0.05)',
  glowPurpleBtn: '0 0 15px rgba(147,51,234,0.3)',
  glowRedDot: '0 0 8px rgba(239,68,68,0.8)',
  glowTealNav: '0 0 12px rgba(94,234,212,0.7)',
  obsidianShadow: 'inset 0 1px 0 rgba(255,255,255,0.05), inset 0 -1px 0 rgba(0,0,0,0.4)',

  // Text
  textWhite: '#ffffff',
  textPrimary: '#e2e8f0',
  textSecondary: '#d1d5db',
  textMuted: '#94a3b8',
  textFaint: '#64748b',
  textFaintest: '#475569',

  // Medal palette — Discover Sectors rail "What's Hot This Week" badges.
  // medalGold mirrors the existing TROPHY_GOLD constant used in Season Mode.
  medalGold: '#F0C75E',
  medalSilver: '#C0C0C0',
  medalBronze: '#CD7F32',
};

// Light mode tokens — secondary priority, placeholders for now
export const LIGHT_TOKENS = {
  bgApp: '#f8fafc',
  bgCard: '#ffffff',
  bgAgent: '#f1f5f9',
  bgElevated: 'rgba(0,0,0,0.02)',
  bgIcon: 'rgba(0,0,0,0.05)',
  borderDefault: 'rgba(0,0,0,0.08)',
  borderPurple: 'rgba(168,85,247,0.15)',
  borderDivider: 'rgba(0,0,0,0.06)',
  borderInput: 'rgba(0,0,0,0.12)',
  teal: '#0d9488',
  emerald: '#059669',
  purple: '#7c3aed',
  purpleText: '#6d28d9',
  red: '#dc2626',
  amber: '#d97706',
  glowPurpleCard: '0 0 20px rgba(168,85,247,0.08)',
  glowPurpleBtn: '0 0 15px rgba(147,51,234,0.2)',
  glowRedDot: '0 0 8px rgba(239,68,68,0.6)',
  glowTealNav: '0 0 12px rgba(13,148,136,0.5)',
  obsidianShadow: 'inset 0 1px 0 rgba(255,255,255,0.7), inset 0 -1px 0 rgba(0,0,0,0.08)',
  textWhite: '#0f172a',
  textPrimary: '#1e293b',
  textSecondary: '#475569',
  textMuted: '#64748b',
  textFaint: '#94a3b8',
  textFaintest: '#cbd5e1',

  // Medal palette — Discover Sectors rail "What's Hot This Week" badges.
  medalGold: '#F0C75E',
  medalSilver: '#C0C0C0',
  medalBronze: '#CD7F32',
};
